import type { Translatable } from "app/pages/sales-intelligence/types";
import { formatCompactNumber } from "app/pages/sales-intelligence/utils/numbers";

import { DEFAULT_ACTION_PANEL_TRANSLATION_KEY } from "../../../constants";
import TopNDropdownItem from "../TopNDropdownItem/TopNDropdownItem";

import type { TopNWithCostDropdownItemDeps } from "./types";

export default class TopNWithCostDropdownItem extends TopNDropdownItem {
    public readonly cost: number;
    public readonly isAvailable: boolean;
    private readonly translationKeyCostModifier: string;

    constructor({ cost, isAvailable, i18nKeyCostModifier, ...deps }: TopNWithCostDropdownItemDeps) {
        super(deps);

        this.cost = cost;
        this.isAvailable = isAvailable;
        this.translationKeyCostModifier = i18nKeyCostModifier ?? DEFAULT_ACTION_PANEL_TRANSLATION_KEY;
    }

    formatCost(): string {
        return formatCompactNumber(this.cost);
    }

    getCostTranslation(): Readonly<Translatable> {
        return {
            key: `si.${this.translationKeyCostModifier}.cost.total`,
            replacements: {
                cost: this.formatCost(),
            },
        };
    }
}
